import { Box, CircularProgress } from '@mui/material';

export function LoginSkeleton() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%', maxWidth: '400px', mx: 'auto' }}>
      <Box sx={{ mb: 2 }}>
        <Box sx={{ height: 32, bgcolor: 'grey.200', borderRadius: 1, mb: 1 }} />
      </Box>

      {/* Email/DNI field skeleton */}
      <Box sx={{ height: 52, bgcolor: 'grey.200', borderRadius: 1 }} />

      {/* Password field skeleton */}
      <Box sx={{ height: 52, bgcolor: 'grey.200', borderRadius: 1 }} />

      {/* Submit button skeleton */}
      <Box
        sx={{
          height: 44,
          bgcolor: 'grey.300',
          borderRadius: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress size={20} />
      </Box>

      {/* Extra buttons skeleton */}
      <Box sx={{ height: 44, bgcolor: 'grey.200', borderRadius: 1 }} />
    </Box>
  );
}
